const THRESHOLD = 1;

export const isGreaterWithThreshold = (a: number, b: number, epsilon = THRESHOLD) => a > b + epsilon;
export const isLessWithThreshold = (a: number, b: number, epsilon = THRESHOLD) => a < b - epsilon;
export const isApproximatelyEqual = (a: number, b: number, epsilon = THRESHOLD) => Math.abs(a - b) < epsilon;
